import React, { useState } from 'react';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { useLocation, useNavigate } from 'react-router-dom';
import { RxCross1 } from "react-icons/rx";
import { SuccessPopUp } from '../../../CommonComponents/SuccessPopUp';

function UpdateCms() {
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');
    const location = useLocation();
    const { cmsData, settingKey } = location.state || {};
    const [cms, setCms] = useState(cmsData);

    const [showPop, setShowPop] = useState(false);
    const [action, setAction] = useState();
    const [navv, setNavv] = useState();
    const [more, setMore] = useState();

    const navBack = useNavigate();
    const updateCms = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/website-cms/${settingKey}`, {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    settingValue: cms
                })
            })
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setAction(getRes.message);
                setShowPop(true);
                setMore();
                setNavv("ok");
            } else {
                setAction(getRes.message);
                setShowPop(true);
                setMore("ok");
                setNavv();
            }
        } catch (e) {
            console.log(e, 'error in cms updartt');
            setAction("Something went wrong !");
            setShowPop(true);
            setMore("ok");
            setNavv();
        }
    };

    const navigate = useNavigate();

    const onClose = () => {
        setShowPop(false);
        setAction();
    };
    const confirmPopUp = () => {
        setShowPop(false);
        navBack('/admin/cms');
    };

    return (
        <>

            <div className="add-item">
                <div className="row">
                    <div className="category-nav">
                        <div className="category-text">
                            <h4>Update {settingKey}</h4>
                        </div>
                        <div className="category-btn" style={{ width: "50%" }}>
                            <button onClick={() => navigate(-1)}><RxCross1 /></button>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>

            <div className="cms-editer">
                <div className="row">
                    <div className="editer">
                        <CKEditor
                            editor={ClassicEditor}
                            config={{
                                toolbar: {
                                    items: [
                                        "heading",
                                        "|",
                                        "bold",
                                        "italic",
                                        "link",
                                        "bulletedList",
                                        "numberedList",
                                        "|",
                                        "indent",
                                        "outdent",
                                        "|",
                                        "imageUpload",
                                        "blockQuote",
                                        "mediaEmbed",
                                        "undo",
                                        "redo",
                                    ],
                                },
                            }}
                            data={cms}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setCms(data);
                            }}
                        />
                    </div>
                    <div className="btn submit-btn">
                        <button onClick={updateCms}>Submit</button>
                    </div>
                </div>
            </div>
            <SuccessPopUp
                isOpen={showPop}
                action={action}
                navv={navv}
                FutherMore={more}
                onClose={onClose}
                onConfirm={confirmPopUp}
            />
        </>
    )
}
export default UpdateCms;